import { pageShowsGeneratingOnCanvas } from '../../lib/comicPageImageStatus'
import { formatPagePanelCapacity, pagePanelCapacity } from '../../lib/comicPageLayout'
import { pageHasGeneratableScript } from '../../lib/comicPagePrompt'
import type { ComicPage, ComicPanel } from '../../lib/comicTypes'
import { ChromePrimaryButton } from '../ChromeActions'
import { ChromeTooltip } from '../ChromeTooltip'

type Props = {
  angular: boolean
  page: ComicPage | null
  pagePanels: ComicPanel[]
  generatingPage: boolean
  platformReady: boolean
  canGenerate?: boolean
  onGeneratePage: () => void
}

/** 分镜栏底部 Dock：整页生图（一张图内含全部画格） */
export function ComicPanelGenerateActions({
  angular,
  page,
  pagePanels,
  generatingPage,
  platformReady,
  canGenerate = true,
  onGeneratePage,
}: Props) {
  if (!page) return null

  const pageGenerating = generatingPage || pageShowsGeneratingOnCanvas(page)
  const cap = pagePanelCapacity(page)
  const canGeneratePage =
    canGenerate &&
    platformReady &&
    !pageGenerating &&
    cap.overflow === 0 &&
    pageHasGeneratableScript(pagePanels)

  const disabledHint =
    !canGenerate
      ? '没有话级生成权限'
      : cap.overflow > 0
        ? `本分镜 ${formatPagePanelCapacity(page)} 超出版式容量`
        : !platformReady && !pageGenerating
          ? '等待模型配置…'
          : null

  const generateButton = (
    <ChromePrimaryButton
      type="button"
      className="w-full"
      disabled={!canGeneratePage}
      onClick={onGeneratePage}
    >
      {pageGenerating
        ? '生成中…'
        : !canGenerate
          ? '无生成权限'
          : !platformReady
            ? '等待模型配置…'
            : '生成本页'}
    </ChromePrimaryButton>
  )

  return (
    <div className="create-prompt-composer-dock flex min-h-0 w-full min-w-0 max-w-full shrink-0 flex-col">
      <div
        className={[
          'flex w-full min-w-0 flex-col gap-2 px-3 pt-2 sm:gap-2.5 sm:px-5 sm:pt-3',
          'pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:pb-4',
        ].join(' ')}
      >
        {disabledHint && !canGeneratePage ? (
          <ChromeTooltip content={disabledHint} angular={angular} side="top" align="center" className="w-full">
            <span className="block w-full">{generateButton}</span>
          </ChromeTooltip>
        ) : (
          generateButton
        )}
      </div>
    </div>
  )
}
